// Master JS for the Meal Train create flow

import { InitCreateFlow } from "./lib/create-flow.js";
import { InitDonationSection } from "./lib/donation-goal.js";
import { WireupEmailPhoneWarning } from "./lib/form-utilities.js";

import { SubmitStatus } from "./webcomponents/submit-status.js";
import { DatePickerCalendar } from "./webcomponents/date-picker-calendar.js";

// Register required webcomponents
SubmitStatus.Register();
DatePickerCalendar.Register();

WireupEmailPhoneWarning();

const form = document.getElementById("create-form");
if (form) {
    const datePicker = document.querySelector("date-picker-calendar");
    // The picker only has boxes for the months it shows, so the draft keeps the dates in this field instead
    const datesField = document.getElementById("Dates");
    datePicker.addEventListener("change", () => datesField.value = datePicker.selected.join(","));

    InitCreateFlow(
        form,
        "/trains/create",
        [
            "Start a Meal Train page",
            "Step 2 - Where should meals be dropped off?",
            "Step 3 - Select dates",
            "Step 4 - Recipient meal preferences",
            "Step 5 - Other forms of support",
        ],
        data => ({
            mealtrain: data.Mealtrain,
            dates: datePicker.selected,
            goal: {
                ...data.Goal,
                // An unchecked checkbox doesn't post at all, so read it rather than trusting its absence
                Declined: document.getElementById("GoalDeclined").checked,
            },
        })
    );
    // The draft restores the field, so hand its dates back to the picker
    if (datesField.value) datePicker.selected = datesField.value.split(",");
}

InitDonationSection();
